import type { VueRoute } from "ui-kit/RouterVue";
import { h } from "vue";

const route: VueRoute = {
  path: "/event-projects",
  action: async () => {
    const c = await import("./views/eventProjects.vue");
    return h(c.default);
  },
};

export default route;
